import React from 'react';

import IconBPMultiplier from '@assets/Icon/svg/BPMultiplier';
import { Row, Col, Pills, MessageBox } from '@ajaibid/components';
import stockService from '@services/stock';

import { useStockBuySellContext, useGetAccountTypeOptions } from '../../hooks';
import { styFormAccountTypePills, styMultiplierBadge } from '../../style';

const SwitchAccountType = () => {
  const {
    code,
    formState,
    formKey,
    formAction,
    dispatch,
    isBuy,
    isSell,
    isAccountDT,
    isAccountMT,
  } = useStockBuySellContext();

  const { isDtBuyTradingHourEnd, isDtSellTradingHourEnd } =
    stockService.account.dt.status.useDtAccountStatus();
  const { isTradeable: isDtTradeable } = stockService.detail.dt.tradeable.useDtTradeable(code);
  const { isTradeable: isMtTradeable } = stockService.detail.mt.tradeable.useMtTradeable(code);

  const { accountTypeOptions } = useGetAccountTypeOptions(code);

  return (
    <>
      <Row
        gutters={2}
        align="between"
        marginTop={12}
        marginBottom={12}
        data-testid="switch-accountType"
      >
        {accountTypeOptions.map((v) => (
          <Col key={v.value} size="auto" className={styFormAccountTypePills(v)}>
            <Pills
              fluid
              active={formState[formKey.INPUT_ACCOUNT_TYPE]?.value === v.value}
              onClick={() => dispatch({ type: formAction.CHANGE_ACCOUNT_TYPE, code, payload: v })}
              data-testid={`switch-accountType-${v.value}`}
            >
              {v.label}
              {v.multiplier && (
                <span
                  className={styMultiplierBadge({ type: v.value })}
                  data-testid={`txt-accountMultiplier-${v.value}`}
                >
                  <IconBPMultiplier size={12} />
                  {`${v.multiplier}x`}
                </span>
              )}
            </Pills>
          </Col>
        ))}
      </Row>
      {isAccountDT && !isDtTradeable && (
        <MessageBox
          type="caution"
          text="Day Trading tidak tersedia untuk saham ini."
          style={{ marginBottom: 12 }}
          data-testid="msg-dtUntradeable"
        />
      )}
      {((isAccountDT && isBuy && isDtBuyTradingHourEnd) ||
        (isAccountDT && isSell && isDtSellTradingHourEnd)) && (
        <MessageBox
          type="caution"
          text="Batas waktu transaksi Day Trading hari ini telah berakhir."
          style={{ marginBottom: 12 }}
          data-testid="msg-dtTradingHourEnd"
        />
      )}
      {isAccountMT && !isMtTradeable && (
        <MessageBox
          type="caution"
          text="Margin Trading tidak tersedia untuk saham ini."
          style={{ marginBottom: 12 }}
          data-testid="msg-mtUntradeable"
        />
      )}
    </>
  );
};

export default SwitchAccountType;
